import { render, staticRenderFns } from "./JoiningKit.vue?vue&type=template&id=66bfb20a&scoped=true&"
import script from "./JoiningKit.vue?vue&type=script&lang=js&"
export * from "./JoiningKit.vue?vue&type=script&lang=js&"
import style0 from "./JoiningKit.vue?vue&type=style&index=0&id=66bfb20a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bfb20a",
  null
  
)

export default component.exports